import { render, staticRenderFns } from "./AuthorsActiveOrdersTable.vue?vue&type=template&id=46152332"
import script from "./AuthorsActiveOrdersTable.vue?vue&type=script&lang=js"
export * from "./AuthorsActiveOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports